import styled from 'styled-components';
import { CarOptionStyled } from '../../CarOptionStyled';
import { rem } from 'polished';

export const CarOptionStyledOV = styled(CarOptionStyled)`
    border-color: ${({ theme }) => theme.colors.grey18};

    &.isSelected,
    &:hover,
    &:focus-visible {
        border-color: ${({ theme }) => theme.colors.primary};
        .inner {
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    &.isSelected {
        background: ${({ theme }) => theme.colors.red7};
    }

    .option-card {
        &__name {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            line-height: 1.25;
            .checkbox .checkboxWrapper label::after {
                border-color: ${({ theme }) => theme.colors.black};
                border-width: 0 3px 3px 0;
            }
        }

        &__imageWrapper {
            &.withOptionIcon {
                &::before {
                    background: unset;
                }
            }
        }
    }
`;
